<app-menu *ngIf="isInternalContext"></app-menu>

<section class="public-question-page" [class.internal-mode]="isInternalContext">
  <header class="public-topbar" [class.internal-mode]="isInternalContext">
    <div class="topbar-inner">
      <img class="topbar-logo" [src]="brandLogoUrl" [alt]="tenantBrand?.tenant_name || 'Logo do tenant'">
      <div class="topbar-progress" *ngIf="survey && !submitted">
        <span>Progresso: {{ progressPercent }}% concluído</span>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progressPercent"></div>
        </div>
      </div>
    </div>
  </header>

  <div class="public-card" [class.with-topbar]="survey && !submitted">
    <header *ngIf="!survey || submitted">
      <h1>{{ survey?.title || 'ControlQuestion' }}</h1>
      <p class="survey-description" *ngIf="survey?.description">{{ survey?.description }}</p>
      <p class="survey-intro" *ngIf="survey?.intro_text">{{ survey?.intro_text }}</p>
    </header>

    <div class="access-panel" *ngIf="!survey && !submitted">
      <label>Senha (se necessário)
        <input type="password" [(ngModel)]="password" placeholder="Digite a senha">
      </label>
      <button class="btn primary" type="button" (click)="accessSurvey()" [disabled]="loading">
        {{ loading ? 'Carregando...' : 'Acessar questionário' }}
      </button>
      <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>

    <form *ngIf="survey && !submitted" class="question-form" [class.read-only]="isReadOnly" (ngSubmit)="submit()">
      <div class="question-list">
        <header class="survey-scroll-header">
          <h1>{{ survey?.title || 'ControlQuestion' }}</h1>
          <p class="survey-description" *ngIf="survey?.description">{{ survey?.description }}</p>
          <p class="survey-intro" *ngIf="survey?.intro_text">{{ survey?.intro_text }}</p>
        </header>

        <div class="question-block" *ngFor="let question of questions; let i = index">
          <div class="question-index">{{ i + 1 }}</div>
          <div class="question-body">
            <h3>
              {{ question.title }}
              <span class="required" *ngIf="question.required">*</span>
            </h3>
            <p *ngIf="question.description">{{ question.description }}</p>
            <div class="question-media" *ngIf="question.media_type === 'IMAGE' && question.media_url">
              <img [src]="question.media_url" [alt]="question.title">
            </div>
            <div class="question-media" *ngIf="question.media_type === 'VIDEO' && question.media_url">
              <video [src]="question.media_url" controls></video>
            </div>

            <div class="options" *ngIf="['SINGLE_CHOICE','DROPDOWN','RANKING'].includes(question.question_type)">
              <label
                class="option"
                *ngFor="let option of getOptions(question.id)"
                [class.is-selected]="answers[question.id] === option.id">
                <input
                  type="radio"
                  [name]="'q' + question.id"
                  [value]="option.id"
                  [disabled]="isReadOnly"
                  [(ngModel)]="answers[question.id]">
                <div class="option-content">
                  <img *ngIf="option.image_url" [src]="option.image_url" [alt]="option.label">
                  <div class="option-label-content">
                    <span *ngIf="getOptionDisplayText(option)">{{ getOptionDisplayText(option) }}</span>
                  </div>
                </div>
              </label>
            </div>

            <div class="emoji-rating" *ngIf="question.question_type === 'EMOJI'">
              <button
                type="button"
                class="emoji-card"
                *ngFor="let option of getRatingOptions(question.id)"
                [class.is-selected]="answers[question.id] === option.id"
                [disabled]="isReadOnly"
                (click)="answers[question.id] = option.id">
                <span class="emoji-icon">{{ getEmojiSymbol(option.label) }}</span>
                <span class="emoji-label">{{ getEmojiText(option.label) }}</span>
              </button>
            </div>

            <div class="star-rating" *ngIf="question.question_type === 'STAR'">
              <button
                type="button"
                class="star-btn"
                *ngFor="let score of [1, 2, 3, 4, 5]"
                [class.is-active]="score <= getSelectedRatingScore(question.id)"
                [disabled]="isReadOnly"
                (click)="selectRatingScore(question.id, score)"
                [attr.aria-label]="'Selecionar ' + score + ' estrela' + (score > 1 ? 's' : '')">
                ★
              </button>
            </div>

            <div class="scale-rating" *ngIf="question.question_type === 'SCALE'">
              <div class="scale-row">
                <button
                  type="button"
                  class="scale-btn"
                  *ngFor="let option of getRatingOptions(question.id)"
                  [class.is-selected]="answers[question.id] === option.id"
                  [disabled]="isReadOnly"
                  (click)="answers[question.id] = option.id">
                  {{ option.label }}
                </button>
              </div>
              <div class="scale-legend">
                <span>Baixo</span>
                <span>Alto</span>
              </div>
            </div>

            <div class="options" *ngIf="question.question_type === 'MULTIPLE_CHOICE'">
              <label
                class="option"
                *ngFor="let option of getOptions(question.id)"
                [class.is-selected]="answers[question.id]?.includes(option.id)">
              <input
                type="checkbox"
                [disabled]="isReadOnly"
                [checked]="answers[question.id]?.includes(option.id)"
                (change)="toggleMulti(question.id, option.id)">
              <div class="option-content">
                <img *ngIf="option.image_url" [src]="option.image_url" [alt]="option.label">
                <span>{{ option.label }}</span>
              </div>
            </label>
            </div>

            <div class="image-grid" *ngIf="question.question_type === 'IMAGE_CHOICE'">
              <label
                class="image-option"
                *ngFor="let option of getOptions(question.id)"
                [class.is-selected]="answers[question.id] === option.id">
                <input
                  type="radio"
                  [name]="'q' + question.id"
                  [value]="option.id"
                  [disabled]="isReadOnly"
                  [(ngModel)]="answers[question.id]">
                <div class="image-card">
                  <img *ngIf="option.image_url" [src]="option.image_url" [alt]="option.label">
                </div>
                <span class="image-caption" *ngIf="getOptionDisplayText(option)">{{ getOptionDisplayText(option) }}</span>
              </label>
            </div>

            <div *ngIf="['TEXT','CUSTOM_TEXT'].includes(question.question_type)">
              <textarea
                rows="3"
                [(ngModel)]="answers[question.id]"
                [name]="'text' + question.id"
                [readonly]="isReadOnly"
                placeholder="Escreva sua resposta aqui..."></textarea>
          </div>

            <div *ngIf="question.question_type === 'EMAIL'">
              <input type="email" [(ngModel)]="answers[question.id]" [name]="'email' + question.id" [readonly]="isReadOnly">
          </div>

            <div *ngIf="question.question_type === 'NUMBER' || question.question_type === 'NPS'">
              <input type="number" [(ngModel)]="answers[question.id]" [name]="'number' + question.id" [readonly]="isReadOnly">
          </div>

            <div *ngIf="question.question_type === 'DATE'">
              <input type="date" [(ngModel)]="answers[question.id]" [name]="'date' + question.id" [readonly]="isReadOnly">
          </div>
          </div>
        </div>
      </div>

      <button *ngIf="!isReadOnly" class="btn primary" type="submit" [disabled]="loading">
        {{ loading ? 'Enviando...' : 'Enviar respostas' }}
      </button>
      <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    </form>

    <div class="success-panel" *ngIf="submitted">
      <h3>Obrigado por responder!</h3>
      <p>Suas respostas foram registradas com sucesso.</p>
      <div class="redirect-loading" *ngIf="redirectingAfterSubmit">
        <span class="spinner" aria-hidden="true"></span>
        <span>Redirecionando...</span>
      </div>
    </div>
  </div>
</section>
